<template>
	<BannerPictureThumbnailForm
		:is-loading="isLoading"
		:banner-type="bannerType"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import BannerPictureThumbnailForm from '@/components/BannerPictureThumbnailForm.vue';

import { BANNER_TYPE } from '../enums/banners';
import { scrollToTop } from '../assets/js/helpers';

export default {
	name: 'BannerPictureThumbnailCreate',

	components: {
		BannerPictureThumbnailForm,
	},

	props: {
		bannerType: {
			type: String,
			default: BANNER_TYPE.picture,
		},
	},

	computed: {
		...mapState('banners', {
			create: 'create',
		}),

		isLoading() {
			return this.create.isLoading;
		},
	},

	methods: {
		...mapActions({
			showToast: 'toast/showToast',
			createBannerGroup: 'banners/createBannerGroup',
		}),

		async handleSubmit(data) {
			try {
				await this.createBannerGroup(data);

				this.$router.push({ name: 'BannerPictureThumbnailList' });
			} catch {
				scrollToTop();
			}
		},
	},
};
</script>
